import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20organic%20mushroom%20farm%20interior%20with%20golden%20morning%20sunlight%20streaming%20through%20large%20windows%2C%20wooden%20shelves%20filled%20with%20various%20fresh%20mushrooms%2C%20warm%20earthy%20tones%2C%20peaceful%20pastoral%20atmosphere%2C%20soft%20natural%20light%2C%20sustainable%20agriculture%20scene%2C%20clean%20organized%20growing%20space&width=1600&height=700&seq=mushroom-hero-bg&orientation=landscape"
        alt="蘑菇成品人视频精选合集"
        title="蘑菇成品人视频精选合集 - 蘑菇种植视频教程大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/55 via-foreground-900/35 to-foreground-900/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl animate-fade-in-up">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium mb-4">
              蘑菇成品人视频精选合集
            </span>
            <h1 className="font-heading text-3xl md:text-5xl text-background-50 leading-tight mb-4">
              掌握蘑菇从培育到成品的
              <span className="text-accent-300">完整视频教程</span>
            </h1>
            <p className="text-base md:text-lg text-background-200/90 leading-relaxed mb-8 max-w-lg">
              汇聚最全面的蘑菇成品人视频资源，涵盖蘑菇种植全流程、成品展示及人工操作技巧，适合新手与专业种植者参考学习。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/all"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                <i className="ri-play-circle-line text-lg"></i>
                观看视频教程
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-lg font-medium text-sm whitespace-nowrap hover:bg-background-50/25 transition-colors"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </Link>
            </div>

            <div className="flex items-center gap-6 mt-10 text-background-200/80">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-video-line text-lg text-accent-400"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-background-50">24+</div>
                  <div className="text-xs">精选视频</div>
                </div>
              </div>
              <div className="w-px h-8 bg-background-50/20"></div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-article-line text-lg text-accent-400"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-background-50">8+</div>
                  <div className="text-xs">深度文章</div>
                </div>
              </div>
              <div className="w-px h-8 bg-background-50/20"></div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-user-smile-line text-lg text-accent-400"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-background-50">50K+</div>
                  <div className="text-xs">学习用户</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}